import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow
} from "@fluentui/react-components";
import {Link, useOutletContext} from "react-router-dom";
import {Button, ButtonGroup, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import {Edit, Delete, Add} from "@mui/icons-material";
import AddAllowed from "../../Panel/Allowed/AddAllowed";
import AddGuardian from "../../Panel/Allowed/AddGuardian";
import EditAllowed from "../../Panel/Allowed/EditAllowed";
import EditGuardian from "../../Panel/Allowed/EditGuardian";

function ChildrenAllowed() {

    const {children} = useOutletContext();
    const [user] = useContext(AuthContext);
    const [allowed, setAllowed] = useState([]);
    const [addGuardian, setAddGuardian] = useState(false);
    const [editGuardian, setEditGuardian] = useState(false);
    const [addAllowed, setAddAllowed] = useState(false);
    const [editAllowed, setEditAllowed] = useState(false);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children/${children}/allowed`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setAllowed(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [children, refresh]);

    function _deleteGuardian(id) {
        fetch(`/api/children/${children}/guardian/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    function _deleteAllowed(id) {
        fetch(`/api/children/${children}/allowed/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    const columns = [
        createTableColumn ({
            columnId: "fullname",
            compare: (a, b) => {
                return a.fullname.localeCompare(b.fullname);
            },
            renderHeaderCell: () => {
                return "Imię i Nazwisko";
            },
            renderCell: (item) => (<Typography variant={'h6'} fontSize={'small'} fontWeight={'bold'}>{item.fullname}</Typography>)
        }),
        createTableColumn ({
            columnId: "kinship",
            compare: (a, b) => {
                return a.kinship.localeCompare(b.kinship);
            },
            renderHeaderCell: () => {
                return "Pokrewieństwo";
            },
            renderCell: (item) => item.kinship
        }),
        createTableColumn ({
            columnId: "phone",
            compare: (a, b) => {
                return a.phone.localeCompare(b.phone);
            },
            renderHeaderCell: () => {
                return "Telefon";
            },
            renderCell: (item) => item.phone
        }),
        createTableColumn ({
            columnId: "more",
            renderHeaderCell: () => {
                return "Akcje";
            },
            renderCell: (item) => {
                if (item.is_guardian) {
                    return <ButtonGroup>
                        <Button variant={'outlined'} color={'success'} onClick={() => setEditGuardian(item)}><Edit /></Button>
                        <Button variant={'outlined'} color={'error'} onDoubleClick={() => _deleteGuardian(item.id)}><Delete /></Button>
                    </ButtonGroup>
                } else {
                    return <ButtonGroup>
                        <Button variant={'outlined'} color={'success'} onClick={() => setEditAllowed(item)}><Edit /></Button>
                        <Button variant={'outlined'} color={'error'} onDoubleClick={() => _deleteAllowed(item.id)}><Delete /></Button>
                    </ButtonGroup>
                }
            }
        }),
    ];

    return (<>
            <ButtonGroup variant={'text'} color={'info'}>
                <Button startIcon={<Add />} onClick={() => setAddGuardian(children)} variant={'text'} color={'info'}>Dodaj Opiekuna Prawnego</Button>
                <Button startIcon={<Add />} onClick={() => setAddAllowed(children)} variant={'text'} color={'info'}>Dodaj Odbierającego</Button>
            </ButtonGroup>
        <DataGrid
            items={allowed}
            columns={columns}
            sortable
            getRowId={(item) => item.id}
            focusMode="composite"
        >
            <DataGridHeader>
                <DataGridRow>
                    {({renderHeaderCell}) => (
                        <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody>
                {({item, rowId}) => (
                    <DataGridRow key={rowId}>
                        {({renderCell}) => (
                            <DataGridCell>{renderCell(item)}</DataGridCell>
                        )}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
            <AddAllowed isOpen={addAllowed} onSuccess={() => setRefresh(r => ++r)} dismiss={() => setAddAllowed(false)} />
            <AddGuardian isOpen={addGuardian} onSuccess={() => setRefresh(r => ++r)} dismiss={() => setAddGuardian(false)} />
            <EditAllowed data={editAllowed} onSuccess={() => setRefresh(r => ++r)} dismiss={() => setEditAllowed(false)} />
            <EditGuardian data={editGuardian} onSuccess={() => setRefresh(r => ++r)} dismiss={() => setEditGuardian(false)} />
        </>
    );
}

export default ChildrenAllowed;